/* import __COLOCATED_TEMPLATE__ from './sq-input-search.hbs.js'; */
var _dec, _dec2, _dec3, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { classNames, classNameBindings } from '@ember-decorators/component';
import { readOnly } from '@ember/object/computed';
/**
## Input Search

SqInputSearch is a text field that sends an event when the search text changes.

```example
@title Basic Usage

@hbs
{{sq-input-search onChange=(action (mut value))}}

Value: {{value}}
```

```example
@title Usage with fluid width

@hbs
{{sq-input-search onChange=(action (mut value))
                  isFluid=true}}

Value: {{value}}
```

### Parameters
 * @param {action} [onChange] [An action that gets triggered when the text changes]
 * @param {String} [searchText] [The text in the component that is being searched for]
 * @param {String} [placeholderText] [The placeholder text]
 * @param {Number} [liveTypingDelay=150] [The time (in ms) that the component waits for additional input before firing the onChange action]
 * @param {Boolean} [isFluid] [The width of the search box should be maximized]

*/

import { debounce } from '@ember/runloop';
import Component from '@ember/component';
export const DEFAULT_SEARCH_KEYPRESS_DELAY = 150; // ms
let SqInputSearch = (_dec = classNames('input-icon', 'input-search'), _dec2 = classNameBindings('isFluid:input-search--fluid'), _dec3 = readOnly('searchText'), _dec(_class = _dec2(_class = (_class2 = class SqInputSearch extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, 'data-test-input-search', _descriptor, this);
    _defineProperty(this, "searchText", null);
    _defineProperty(this, "prevSearchText", null);
    _defineProperty(this, "placeholderText", null);
    _defineProperty(this, "isFocused", false);
    _defineProperty(this, "isFluid", false);
    _defineProperty(this, "disabled", false);
    _defineProperty(this, "liveTypingDelay", DEFAULT_SEARCH_KEYPRESS_DELAY);
  }
  init(...args) {
    super.init(...args);
    this.set('prevSearchText', this.searchText);
  }
  focusIn(...args) {
    this.set('isFocused', true);
    if (this.onFocusIn) {
      this.onFocusIn(...args);
    }
  }
  focusOut(...args) {
    this.set('isFocused', false);
    if (this.onFocusOut) {
      this.onFocusOut(...args);
    }
  }

  // debounce while typing
  input() {
    debounce(this, this.debouncedOnSearchTextChanged, this.liveTypingDelay, false);
  }

  // fire immediately on blur (should be no-op most of the time because
  // the action already fired on input)
  change() {
    this.onSearchTextChanged();
  }
  debouncedOnSearchTextChanged() {
    this.onSearchTextChanged();
  }

  // send the event only if the text actually
  // changes to account for the two event types
  onSearchTextChanged() {
    const newText = this.searchText || '';
    const oldText = this.prevSearchText || '';
    if (!this.isDestroyed) {
      if (newText !== oldText) {
        this.onChange?.(newText);
      }
      this.set('prevSearchText', newText);
    }
  }
  clearSearch() {
    this.set('searchText', null);
    this.onSearchTextChanged(null);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, 'data-test-input-search', [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "clearSearch", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "clearSearch"), _class2.prototype), _class2)) || _class) || _class);
export { SqInputSearch as default };